export default "__VITE_ASSET__8a67ef31__"